import miami_degen_thumbnail from '../../thumbnails/miami_degen_thumbnail.jpg';
import ny_degen_thumbnail from '../../thumbnails/ny_degen_thumbnail.jpg';
import sdgu_stackspunks_thumbnail from '../../thumbnails/sdgu_stackspunks_thumbnail.png';
import bitcoin_degens_thumbnail from '../../thumbnails/bitcoin_degens_thumbnail.png';
import React, { useCallback, useState } from 'react';
import { Button } from '../common';
import { MenuContainer } from './MenuContainer';
import { DegenCollectionCard } from './DegenCollectionCard';
import { DegenRacerByCollection } from './DegenRacerByCollection';
import { DegenCollection, collectionConstMapping } from '../../constants/collections';
import { collectionMapping, IDegenCollectionsProps } from '../../constants/collectionMapping';
export type DegenPage = 'CollectionPicker' | DegenCollection;

export const DegenCollections = (props: IDegenCollectionsProps) => {
  const [degenPage, setDegenPage] = useState<DegenPage>('CollectionPicker');
  const onClickBackToDegenPicker = useCallback(() => setDegenPage('CollectionPicker'), []);
  const onClickMiami = useCallback(() => setDegenPage('Miami'), []);
  const onClickNYC = useCallback(() => setDegenPage('NYC'), []);
  const onClickSDGU = useCallback(() => setDegenPage('SDGU'), []);
  const onClickBitcoin = useCallback(() => setDegenPage('Bitcoin'), []);
  const openLink = (link: string) => {
    window.open(link, '_blank');
  };

  const { nftsOwnedMiamiDegens, nftsOwnedNYCDegens, nftsOwnedSDGUStacksPunks, nftsOwnedBitcoin, onClickBack } = props;

  if (degenPage === 'CollectionPicker') {
    const content = (
      <div className="degen-collection-container">
        <DegenCollectionCard thumbnail={miami_degen_thumbnail} title={'Miami Degens'} onClick={onClickMiami} />
        <DegenCollectionCard thumbnail={ny_degen_thumbnail} title={'NYC Degens'} onClick={onClickNYC} />
        <DegenCollectionCard thumbnail={bitcoin_degens_thumbnail} title={'Bitcoin Degens'} onClick={onClickBitcoin} />
        <DegenCollectionCard thumbnail={sdgu_stackspunks_thumbnail} title={'SDGU StacksPunks'} onClick={onClickSDGU} />
      </div>
    );

    const footer = (
      <>
        <Button label={'Back'} secondary={true} className={'mx-2'} onClick={onClickBack} />
        <Button
          label={'Mint Bitcoin Degen'}
          secondary={true}
          className={'mx-2'}
          onClick={() => openLink('https://stacksdegens.com/mint-bitcoin-degens/')}
        />
      </>
    );

    return <MenuContainer content={content} footer={footer} />;
  }

  let collection = collectionMapping[degenPage](nftsOwnedMiamiDegens, collectionConstMapping);
  if (degenPage == 'Miami') collection = collectionMapping[degenPage](nftsOwnedMiamiDegens, collectionConstMapping);
  else if (degenPage == 'NYC') collection = collectionMapping[degenPage](nftsOwnedNYCDegens, collectionConstMapping);
  else if (degenPage == 'SDGU')
    collection = collectionMapping[degenPage](nftsOwnedSDGUStacksPunks, collectionConstMapping);
  else if (degenPage == 'Bitcoin') collection = collectionMapping[degenPage](nftsOwnedBitcoin, collectionConstMapping);
  return (
    <DegenRacerByCollection
      nftsOwned={collection.nftsOwned}
      baseSource={collection.baseSource}
      collectionName={collection.collectionName}
      onClickMainMenu={onClickBack}
      onClickBack={onClickBackToDegenPicker}
    />
  );
};
